
import { PageLayout } from '@/components/layout/PageLayout';
import { ModuleEditor } from '@/components/admin/ModuleEditor';

const AdminModuleEdit = () => {
  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-6">
        <ModuleEditor />
      </div>
    </PageLayout>
  );
};

export default AdminModuleEdit;
